// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UuLI","comment":"styles_comment__3agn8"};